import React, { Fragment } from "react";

import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { default as BaseModal } from "@ds-developer/modal";
import { formatDateShort, formatTime } from "@ds-developer/frontend";
import Button from "@ds-developer/button";

import { EditTimeOffModalProps } from "./types";
import Skeleton from "./components/Skeleton";

const useStyles = makeStyles(theme => ({
  switchLabel: {
    marginLeft: theme.spacing(0),
    width: "100%",
    justifyContent: "space-between",
  },
  selectContainer: {
    paddingRight: "0 !important", // can't find another way to override MUI styles
  },
  selectIcon: {
    display: "none",
  },
}));

const EditTimeOffModal: React.FC<EditTimeOffModalProps> = ({
  allDay,
  startTime,
  endTime,
  repeat = "",
  loading = false,
  onDeleteEventClicked = () => {},
  onSaveClicked = () => {},
  onHandleNotesEventClick = () => {},
  updating = false,
  register,
  errors,
  isValid,
  submitting,
}) => {
  const classes = useStyles();

  const actions = (
    <Fragment>
      <Button
        variant="outlined"
        disabled={submitting}
        onClick={onDeleteEventClicked}
      >
        Delete unavailable slot
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={onSaveClicked || submitting}
        disabled={!isValid || updating}
      >
        Save
      </Button>
    </Fragment>
  );

  return (
    <BaseModal actions={actions} open title="Edit unavailable slot">
      {loading ? (
        <Skeleton />
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              classes={{ labelPlacementStart: classes.switchLabel }}
              control={<Switch checked={allDay} disabled />}
              label="All day?"
              labelPlacement="start"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Start date"
              variant="outlined"
              value={startTime && formatDateShort(startTime)}
              InputProps={{ disabled: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Start time"
              variant="outlined"
              value={startTime && formatTime(startTime)}
              InputProps={{ disabled: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="End date"
              variant="outlined"
              value={endTime && formatDateShort(endTime)}
              InputProps={{ disabled: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="End time"
              variant="outlined"
              value={endTime && formatTime(endTime)}
              InputProps={{ disabled: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography>Repeat</Typography>
              <FormControl>
                <Select
                  classes={{
                    select: classes.selectContainer,
                    icon: classes.selectIcon,
                  }}
                  disabled
                  disableUnderline
                  displayEmpty
                  name="repeat"
                  value={repeat}
                >
                  <MenuItem value="">No repeat</MenuItem>
                  <MenuItem value="DAILY">Every day</MenuItem>
                  <MenuItem value="WEEKLY">Every week</MenuItem>
                  <MenuItem value="MONTHLY">Every month</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="edit-time-off-modal-notes"
              multiline
              label="Notes"
              variant="outlined"
              name="notes"
              inputRef={register}
              helperText={errors?.notes?.message}
              error={Boolean(errors?.notes)}
              disabled={updating}
              onClick={onHandleNotesEventClick}
            />
          </Grid>
        </Grid>
      )}
    </BaseModal>
  );
};

export default EditTimeOffModal;
